import * as actionTypes from '../actions/actionTypes';

const initialState = {
  status: null,
  netWorkConnection: true,
};

const status = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CHANGE_STATUS:
      return {
        ...state,
        status: action.payload.status,
      };
    case actionTypes.ISSUE_REPORT:
      return {
        ...state,
        netWorkConnection: action.payload.netWorkConnection,
      };
    case actionTypes.ISSUE_REPORT_RESET:
      return {
        ...state,
        netWorkConnection: true,
      };
    case actionTypes.RESET_STATUS:
      return initialState;
    default:
      return {
        ...state,
      };
  }
};

export default status;
